export const iosAppStoreUrl = 'https://apps.apple.com/app/blockchain-exchange-buy-btc/id1557515848'
export const androidAppStoreUrl =
  'https://play.google.com/store/apps/details?id=com.blockchain.exchange'
